import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../common/helpers/helpers";
import Expander from "../../components/Expander";
import GeneWithRefGenomeLink from "../../common/helpers/GeneWithRefGenomeLink";
import { primaryColor1 } from "../../common/helpers/colors";
import HelperText from "../../components/atoms/HelperText";

const TranscriptDetailsTable = (props) => {
  const { handleClick, genomeSubdomain, trans, varsomeHost } = props;
  return (
    <table className="varsome-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Gene</th>
          <th>Strand</th>
          <th>Chromosome</th>
          <th>Position</th>
          <th>Length</th>
          <th>mRNA length</th>
          <th>Coding length</th>
          <th>
            TSL <HelperText fieldDescriptionKey="TSL" />
          </th>
        </tr>
      </thead>
      <Expander showMore="10" component="tbody">
        {trans.map((item, i) => {
          return (
            <tr key={i}>
              <td>
                {item.active && (
                  <span>
                    <strong>{item.name}</strong>
                    <br />
                    {item.name.startsWith("ENST") ? (
                      <a
                        href={getVarsoUrl(
                          `http://${genomeSubdomain}.ensembl.org/Homo_sapiens/Transcript/Summary?t=${item.name}`
                        )}
                        target="_blank"
                      >
                        <small style={{ color: primaryColor1 }}>
                          See on Ensembl
                        </small>
                      </a>
                    ) : (
                      <a
                        href={getVarsoUrl(
                          `https://www.ncbi.nlm.nih.gov/nuccore/${item.name}`
                        )}
                        target="_blank"
                      >
                        <small style={{ color: primaryColor1 }}>
                          See on NCBI
                        </small>
                      </a>
                    )}
                  </span>
                )}
                {!item.active && (
                  <span>
                    <a
                      onClick={() => {
                        handleClick(item);
                      }}
                    >
                      {item.name} <i className="fa fa-search" />
                    </a>
                    <br />
                    {item.name.startsWith("ENST") ? (
                      <a
                        href={getVarsoUrl(
                          `http://${genomeSubdomain}.ensembl.org/Homo_sapiens/Transcript/Summary?t=${item.name}`
                        )}
                        target="_blank"
                      >
                        <small style={{ color: primaryColor1 }}>
                          See on Ensembl
                        </small>
                      </a>
                    ) : (
                      <a
                        href={getVarsoUrl(
                          `https://www.ncbi.nlm.nih.gov/nuccore/${item.name}`
                        )}
                        target="_blank"
                      >
                        <small style={{ color: primaryColor1 }}>
                          See on NCBI
                        </small>
                      </a>
                    )}
                  </span>
                )}
              </td>
              <td>
                {item.gene_symbol && (
                  <GeneWithRefGenomeLink
                    url={`${varsomeHost}/gene/${item.gene_symbol}`}
                    style={{ wordWrap: "break-word" }}
                    href={`${varsomeHost}/gene/${item.gene_symbol}`}
                    goInternally={true}
                  >
                    {item.gene_symbol}
                  </GeneWithRefGenomeLink>
                )}
                {!item.gene_symbol && "-"}
              </td>
              <td className="tw-text-2xl">{item.strand === "+" ? "↦" : "↤"}</td>
              <td>{item.cytoband ? item.cytoband : item.chromo}</td>
              <td>{item.position}</td>
              <td>{item.length}</td>
              <td>{item.mrna_length}</td>
              <td>{item.coding_length ? item.coding_length : "Non-coding"}</td>
              <td>{item.ensembl_support_level || "-"}</td>
            </tr>
          );
        })}
      </Expander>
    </table>
  );
};

TranscriptDetailsTable.propTypes = {
  trans: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      canonical: PropTypes.bool,
      cds_end: PropTypes.number,
      cds_start: PropTypes.number,
      chromo: PropTypes.string,
      coding_length: PropTypes.number,
      coding_transcript: PropTypes.bool,
      cytoband: PropTypes.string,
      exon_count: PropTypes.number,
      exons: PropTypes.arrayOf(
        PropTypes.shape({
          end: PropTypes.number,
          start: PropTypes.number,
        })
      ),
      gene_id: PropTypes.number,
      gene_symbol: PropTypes.string,
      length: PropTypes.number,
      mrna_length: PropTypes.number,
      name: PropTypes.string,
      position: PropTypes.number,
      strand: PropTypes.string,
      total_coding_length: PropTypes.number,
      total_exon_length: PropTypes.number,
    })
  ),
  genomeSubdomain: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  varsomeHost: PropTypes.string,
};

TranscriptDetailsTable.defaultProps = {
  trans: [],
  genomeSubdomain: null,
  varsomeHost: null,
};

export default TranscriptDetailsTable;
